import { put, takeEvery, takeLatest, all, call } from "redux-saga/effects";
import Constants from "common/Constants";
import axios from "axios";
import qs from "qs";

import * as types from 'containers/csboard/ActionType';
import {
    ANOUN_LIST_SUCCESS, ANOUN_LIST_FAILURE,
    ANOUN_DETAILED_SUCCESS, ANOUN_DETAILED_FAILURE,
    FAQ_LIST_SUCCESS, FAQ_LIST_FAILURE,
    TERMS_CONDITIONS_SUCCESS, TERMS_CONDITIONS_FAILURE,
    NIMPT_ANOUNALL_SUCCESS, NIMPT_ANOUNALL_FAILURE,
    MTRL_CONDITION_REQUEST,
    MTRL_CONDITION_SUCCESS,
    MTRL_CONDITION_FAILURE,
    MTRL_LIST_REQUEST,
    MTRL_LIST_SUCCESS,
    MTRL_LIST_FAILURE,
    MTRL_FILE_REQUEST,
    MTRL_FILE_SUCCESS,
    MTRL_FILE_FAILURE,

} from "containers/csboard/Action";


const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const injectQueryParam = (api, param) => {
    if (typeof api !== "string") return;

    for (let key in param) {
        let regExp = new RegExp("{" + key + "}", "g");
        api = api.replace(regExp, param[key]);
    }
    return api;
};

function* anounListSaga(action) {
    try {
        const keyWord = action.payload.keyword;
        const searchType = action.payload.searchType;
        const from = action.payload.from;
        const size = action.payload.size;

        let param = {
            REQUEST_API: Constants.CSBOARD_API.ANOUN_LIST,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        let queryParam = {
            SEARCH_TYPE: searchType,
            KEY_WORD: keyWord,
            FROM: from,
            SIZE: size
        };

        param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

        const { data } = yield axios({
            method: "post",
            baseURL: "/common/api",
            data: qs.stringify(param),
            CancelToken: source.token
        })

        const result = data.RESP_RESULT.RESP_RESULT;

        yield put(ANOUN_LIST_SUCCESS(result));

    } catch (e) {
        yield put(ANOUN_LIST_FAILURE(e.message));
    }
}

function* nimptAnounListSaga(action) {
    try {
        const keyWord = action.payload.keyword;
        const searchType = action.payload.searchType;
        const from = action.payload.from;
        const size = action.payload.size;

        let param = {
            REQUEST_API: Constants.CSBOARD_API.ANOUN_LIST,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        let queryParam = {
            SEARCH_TYPE: searchType,
            KEY_WORD: keyWord,
            FROM: from,
            SIZE: size
        };

        param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

        const { data } = yield axios({
            method: "post",
            baseURL: "/common/api",
            data: qs.stringify(param),
            CancelToken: source.token
        })

        const result = data.RESP_RESULT.RESP_RESULT;

        yield put(NIMPT_ANOUNALL_SUCCESS(result));

    } catch (e) {
        yield put(NIMPT_ANOUNALL_FAILURE(e.message));
    }
}

function* anounDetailedSaga(action) {
    try {
        const anounSeq = action.payload.anounSeq;

        let param = {
            REQUEST_API: Constants.CSBOARD_API.ANOUN_DETAILED,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        let queryParam = {
            ANOUN_SEQ: anounSeq,
        };

        param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

        const { data } = yield axios({
            method: "post",
            baseURL: "/common/api",
            data: qs.stringify(param),
            CancelToken: source.token
        })

        const result = data.RESP_RESULT.RESP_RESULT;

        yield put(ANOUN_DETAILED_SUCCESS(result));

    } catch (e) {
        yield put(ANOUN_DETAILED_FAILURE(e.message));
    }
}

function* faqListSaga(action) {
    try {
        const keyWord = action.payload.keyword;
        const searchType = action.payload.searchType;

        let param = {
            REQUEST_API: Constants.CSBOARD_API.FAQ_LIST,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        let queryParam = {
            SEARCH_TYPE: searchType,
            KEY_WORD: keyWord
        };

        param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

        const { data } = yield axios({
            method: "post",
            baseURL: "/common/api",
            data: qs.stringify(param),
            CancelToken: source.token
        })


        const result = data.RESP_RESULT.RESP_RESULT;
        console.log("result")
        console.log(result)
        yield put(FAQ_LIST_SUCCESS(result));

    } catch (e) {
        yield put(FAQ_LIST_FAILURE(e.message));
    }
}

function* termsConditionsSaga(action) {
    try {
        const dvsn_cd = action.payload.dvsn_cd;

        let param = {
            REQUEST_API: Constants.CSBOARD_API.GET_TERMS_CONDITiONS,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        let queryParam = {
            DVSN_CD: dvsn_cd
        };

        param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

        const { data } = yield axios({
            method: "post",
            baseURL: "/common/api",
            data: qs.stringify(param),
            CancelToken: source.token
        })

        const result = data.RESP_RESULT.RESP_RESULT;

        yield put(TERMS_CONDITIONS_SUCCESS(result));

    } catch (e) {
        yield put(TERMS_CONDITIONS_FAILURE(e.message));
    }
}

function* mtrlConditionsSaga(action) {
    try {
        let param = {
            REQUEST_API: Constants.CSBOARD_API.MTRL_CONDITiONS,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };
        let queryParam = {
            CTGR_TY: action.payload.ctgrTy ? action.payload.ctgrTy : "ALL",
            CTGR_CD: action.payload.ctgrCd ? action.payload.ctgrCd : "ALL",
            GRAD_CD: action.payload.gradCd ? action.payload.gradCd : "ALL",
            MMBR_SEQ: action.payload.mmbrSeq ? action.payload.mmbrSeq : "ALL",
            MTRL_DVSN_CD: action.payload.mtrlDvsnCd ? action.payload.mtrlDvsnCd : "ALL",
            CLAS_SEQ: action.payload.clasSeq ? action.payload.clasSeq : "ALL",
        };
        param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);
        const { data } = yield axios({
            method: "post",
            baseURL: "/common/api",
            data: qs.stringify(param),
            CancelToken: source.token
        })
        const result = data.RESP_RESULT.RESP_RESULT;
        yield put(MTRL_CONDITION_SUCCESS(result));
    } catch (e) {
        yield put(MTRL_CONDITION_FAILURE(e.message));
    }
}

function* mtrlListSaga(action) {
    try {
        const pageCnt = action.payload.pageCnt;
        let param = {
            REQUEST_API: Constants.CSBOARD_API.MTRL_LIST + "?PAGE_CNT=" + pageCnt,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        let queryParam = {
            CTGR_TY: action.payload.ctgrTy ? action.payload.ctgrTy : "ALL",
            CTGR_CD: action.payload.ctgrCd ? action.payload.ctgrCd : "ALL",
            GRAD_CD: action.payload.gradCd ? action.payload.gradCd : "ALL",
            COURSE_GRP_CD: action.payload.courseCd ? action.payload.courseCd : "ALL",
            STD_MTRL_TITE: action.payload.stdMtrlTite ? action.payload.stdMtrlTite : "ALL",
            MMBR_SEQ: action.payload.mmbrSeq ? action.payload.mmbrSeq : "ALL",
            MTRL_DVSN_CD: action.payload.mtrlDvsnCd ? action.payload.mtrlDvsnCd : "ALL",
            CLAS_SEQ: action.payload.clasSeq ? action.payload.clasSeq : "ALL",
        };
        param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);
        
        const { data } = yield axios({
            method: "post",
            baseURL: "/common/api",
            data: qs.stringify(param),
            CancelToken: source.token
        })

        const result = data.RESP_RESULT.RESP_RESULT;
        yield put(MTRL_LIST_SUCCESS(result));
    } catch (e) {
        yield put(MTRL_LIST_FAILURE(e.message));
    }
}

function* mtrlFileSaga(action) {
    try {
        let param = {
            REQUEST_API: Constants.CSBOARD_API.MTRL_FILE_INFO,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        let queryParam = {
            STD_MTRL_SEQ: action.payload.stdMtrlSeq,
            MMBR_SEQ: action.payload.mmbrSeq ? action.payload.mmbrSeq : "ALL",
        };
        param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

        const { data } = yield axios({
            method: "post",
            baseURL: "/common/api",
            data: qs.stringify(param),
            CancelToken: source.token
        })

        const result = data.RESP_RESULT.RESP_RESULT;
        yield put(MTRL_FILE_SUCCESS(result));
    } catch (e) {
        yield put(MTRL_FILE_FAILURE(e.message));
    }
}

export function* onMtrlFileRequset() {
    yield takeLatest(types.MTRL_FILE_REQUEST, mtrlFileSaga)
}
export function* onMtrlConditionsRequset() {
    yield takeLatest(types.MTRL_CONDITION_REQUEST, mtrlConditionsSaga)
}
export function* onMtrlListRequset() {
    yield takeLatest(types.MTRL_LIST_REQUEST, mtrlListSaga)
}

export function* onAnounListRequest() {
    yield takeLatest(types.ANOUN_LIST_REQUEST, anounListSaga)
}

export function* onAnounDetailedRequest() {
    yield takeLatest(types.ANOUN_DETAILED_REQUEST, anounDetailedSaga)
}

export function* onFaqListRequest() {
    yield takeLatest(types.FAQ_LIST_REQUEST, faqListSaga)
}

export function* onTermsConditionsRequset() {
    yield takeLatest(types.TERMS_CONDITIONS_REQUEST, termsConditionsSaga)
}

export function* onNimptAnounAllRequest() {
    yield takeLatest(types.NIMPT_ANOUNALL_REQUEST, nimptAnounListSaga)
}

export default function* CSBoardSaga() {
    yield all([
        call(onAnounListRequest),
        call(onAnounDetailedRequest),
        call(onFaqListRequest),
        call(onTermsConditionsRequset),
        call(onNimptAnounAllRequest),
        call(onMtrlConditionsRequset),
        call(onMtrlListRequset),
        call(onMtrlFileRequset)
    ])
}